module.exports = __webpack_public_path__ + "img/show.b3b03ef1.svg";